import {
  LineInterface,
  SectionInterface,
  LineSectionBaseInterface,
} from '../lines/types';
import { TransportCardInterface } from '../transportCards/types';
import { DbdInterface } from '../dbds/types';
import { FareInterface } from '../fares/types';
import { TokenInterface } from '../itineraries/types';

/*
 * Action Types
 */
export enum ReportsTypes {
  GET_CHART_REPORT_REQUEST = '@reports/GET_CHART_REPORT_REQUEST',
  GET_CHART_REPORT_SUCCESS = '@reports/GET_CHART_REPORT_SUCCESS',
  GET_CHART_REPORT_FAILURE = '@reports/GET_CHART_REPORT_FAILURE',

  GET_INVOICES_LIST_REQUEST = '@reports/GET_INVOICES_LIST_REQUEST',
  GET_INVOICES_LIST_SUCCESS = '@reports/GET_INVOICES_LIST_SUCCESS',
  GET_INVOICES_LIST_FAILURE = '@reports/GET_INVOICES_LIST_FAILURE',

  LIST_INVOICES_LIST_REQUEST = '@reports/LIST_INVOICES_LIST_REQUEST',

  GET_PASSENGERS_BY_ORIGIN_REPORT_REQUEST = '@reports/GET_PASSENGERS_BY_ORIGIN_REPORT_REQUEST',
  GET_PASSENGERS_BY_ORIGIN_REPORT_SUCCESS = '@reports/GET_PASSENGERS_BY_ORIGIN_REPORT_SUCCESS',
  GET_PASSENGERS_BY_ORIGIN_REPORT_FAILURE = '@reports/GET_PASSENGERS_BY_ORIGIN_REPORT_FAILURE',

  GET_TRANSPORTED_PASSENGERS_REPORT_REQUEST = '@reports/GET_TRANSPORTED_PASSENGERS_REPORT_REQUEST',
  GET_TRANSPORTED_PASSENGERS_REPORT_SUCCESS = '@reports/GET_TRANSPORTED_PASSENGERS_REPORT_SUCCESS',
  GET_TRANSPORTED_PASSENGERS_REPORT_FAILURE = '@reports/GET_TRANSPORTED_PASSENGERS_REPORT_FAILURE',

  GET_KM_DRIVED_REPORT_REQUEST = '@reports/GET_KM_DRIVED_REPORT_REQUEST',
  GET_KM_DRIVED_REPORT_SUCCESS = '@reports/GET_KM_DRIVED_REPORT_SUCCESS',
  GET_KM_DRIVED_REPORT_FAILURE = '@reports/GET_KM_DRIVED_REPORT_FAILURE',

  GET_GATE_ENTRY_REPORT_REQUEST = '@reports/GET_GATE_ENTRY_REPORT_REQUEST',
  GET_GATE_ENTRY_REPORT_SUCCESS = '@reports/GET_GATE_ENTRY_REPORT_SUCCESS',
  GET_GATE_ENTRY_REPORT_FAILURE = '@reports/GET_GATE_ENTRY_REPORT_FAILURE',

  LIST_CAR_REPORT_REQUEST = '@reports/LIST_CAR_REPORT_REQUEST',
  LIST_CAR_REPORT_SUCCESS = '@reports/LIST_CAR_REPORT_SUCCESS',
  LIST_CAR_REPORT_FAILURE = '@reports/LIST_CAR_REPORT_FAILURE',

  LINE_DEMAND_REPORT_REQUEST = '@reports/LINE_DEMAND_REPORT_REQUEST',
  LINE_DEMAND_REPORT_SUCCESS = '@reports/LINE_DEMAND_REPORT_SUCCESS',
  LINE_DEMAND_REPORT_FAILURE = '@reports/LINE_DEMAND_REPORT_FAILURE',

  LINE_QUANTITY_REPORT_REQUEST = '@reports/LINE_QUANTITY_REPORT_REQUEST',
  LINE_QUANTITY_REPORT_SUCCESS = '@reports/LINE_QUANTITY_REPORT_SUCCESS',
  LINE_QUANTITY_REPORT_FAILURE = '@reports/LINE_QUANTITY_REPORT_FAILURE',
  KM_BY_DAY_REPORT_REQUEST = '@reports/KM_BY_DAY_REPORT_REQUEST',
  KM_BY_DAY_REPORT_SUCCESS = '@reports/KM_BY_DAY_REPORT_SUCCESS',
  KM_BY_DAY_REPORT_FAILURE = '@reports/KM_BY_DAY_REPORT_FAILURE',

  TRANSPORTED_PASSENGERS_BY_TIMEFRAME_REPORT_REQUEST = '@reports/TRANSPORTED_PASSENGERS_BY_TIMEFRAME_REPORT_REQUEST',
  TRANSPORTED_PASSENGERS_BY_TIMEFRAME_REPORT_SUCCESS = '@reports/TRANSPORTED_PASSENGERS_BY_TIMEFRAME_REPORT_SUCCESS',
  TRANSPORTED_PASSENGERS_BY_TIMEFRAME_REPORT_FAILURE = '@reports/TRANSPORTED_PASSENGERS_BY_TIMEFRAME_REPORT_FAILURE',

  TRANSPORTED_PASSENGERS_BY_TIMEFRAME_BY_PROFILE_REPORT_REQUEST = '@reports/TRANSPORTED_PASSENGERS_BY_TIMEFRAME_BY_PROFILE_REPORT_REQUEST',
  TRANSPORTED_PASSENGERS_BY_TIMEFRAME_BY_PROFILE_REPORT_SUCCESS = '@reports/TRANSPORTED_PASSENGERS_BY_TIMEFRAME_BY_PROFILE_REPORT_SUCCESS',
  TRANSPORTED_PASSENGERS_BY_TIMEFRAME_BY_PROFILE_REPORT_FAILURE = '@reports/TRANSPORTED_PASSENGERS_BY_TIMEFRAME_BY_PROFILE_REPORT_FAILURE',

  DAILY_DEMAND_REPORT_REQUEST = '@reports/DAILY_DEMAND_REPORT_REQUEST',
  DAILY_DEMAND_REPORT_SUCCESS = '@reports/DAILY_DEMAND_REPORT_SUCCESS',
  DAILY_DEMAND_REPORT_FAILURE = '@reports/DAILY_DEMAND_REPORT_FAILURE',

  DAILY_QUANTITY_REPORT_REQUEST = '@reports/DAILY_QUANTITY_REPORT_REQUEST',
  DAILY_QUANTITY_REPORT_SUCCESS = '@reports/DAILY_QUANTITY_REPORT_SUCCESS',
  DAILY_QUANTITY_REPORT_FAILURE = '@reports/DAILY_QUANTITY_REPORT_FAILURE',

  DAILY_QUANTITY_SECCIONED_REPORT_REQUEST = '@reports/DAILY_QUANTITY_SECCIONED_REPORT_REQUEST',
  DAILY_QUANTITY_SECCIONED_REPORT_SUCCESS = '@reports/DAILY_QUANTITY_SECCIONED_REPORT_SUCCESS',
  DAILY_QUANTITY_SECCIONED_REPORT_FAILURE = '@reports/DAILY_QUANTITY_SECCIONED_REPORT_FAILURE',

  GET_CHART_ENTRY_REPORT_REQUEST = '@reports/GET_CHART_ENTRY_REPORT_REQUEST',
  GET_CHART_ENTRY_REPORT_SUCCESS = '@reports/GET_CHART_ENTRY_REPORT_SUCCESS',
  GET_CHART_ENTRY_REPORT_FAILURE = '@reports/GET_CHART_ENTRY_REPORT_FAILURE',

  GET_CHART_ENTRY_REPORT_SIMPLIFIED_REQUEST = '@reports/GET_CHART_ENTRY_REPORT_SIMPLIFIED_REQUEST',
  GET_CHART_ENTRY_REPORT_SIMPLIFIED_SUCCESS = '@reports/GET_CHART_ENTRY_REPORT_SIMPLIFIED_SUCCESS',
  GET_CHART_ENTRY_REPORT_SIMPLIFIED_FAILURE = '@reports/GET_CHART_ENTRY_REPORT_SIMPLIFIED_FAILURE',

  GET_SUPERIOR_ACCESS_REPORT_REQUEST = '@reports/GET_SUPERIOR_ACCESS_REPORT_REQUEST',
  GET_SUPERIOR_ACCESS_REPORT_SUCCESS = '@reports/GET_SUPERIOR_ACCESS_REPORT_SUCCESS',
  GET_SUPERIOR_ACCESS_REPORT_FAILURE = '@reports/GET_SUPERIOR_ACCESS_REPORT_FAILURE',

  ENTRY_REPORT_GROUPED_REQUEST = '@reports/ENTRY_REPORT_GROUPED_REQUEST',
  ENTRY_REPORT_GROUPED_SUCCESS = '@reports/ENTRY_REPORT_GROUPED_SUCCESS',
  ENTRY_REPORT_GROUPED_FAILURE = '@reports/ENTRY_REPORT_GROUPED_FAILURE',

  CREATE_CHIPS_LIST_ENTRY = '@reports/CREATE_CHIPS_LIST_ENTRY',
  CLEAN_CHIPS_LIST_ENTRY = '@reports/CLEAN_CHIPS_LIST_ENTRY',

  CREATE_CHIPS_LIST_VALUE = '@reports/CREATE_CHIPS_LIST_VALUE',
  CLEAN_CHIPS_LIST_VALUE = '@reports/CLEAN_CHIPS_LIST_VALUE',

  CREATE_CHIPS_LIST_LINE = '@reports/CREATE_CHIPS_LIST_LINE',
  CLEAN_CHIPS_LIST_LINE = '@reports/CLEAN_CHIPS_LIST_LINE',

  CREATE_CHIPS_HEATMAP = '@reports/CREATE_CHIPS_HEATMAP',
  CLEAN_CHIPS_HEATMAP = '@reports/CLEAN_CHIPS_HEATMAP',

  CREATE_CHIPS_FLEET = '@reports/CREATE_CHIPS_FLEET',

  CREATE_CHIPS_TRAVEL = '@reports/CREATE_CHIPS_TRAVEL',
  CLEAN_CHIPS_TRAVEL = '@reports/CLEAN_CHIPS_TRAVEL',

  GET_HEATMAP_REPORT_REQUEST = '@reports/GET_HEATMAP_REPORT_REQUEST',
  GET_HEATMAP_REPORT_SUCCESS = '@reports/GET_HEATMAP_REPORT_SUCCESS',
  GET_HEATMAP_REPORT_FAILURE = '@reports/GET_HEATMAP_REPORT_FAILURE',

  PAYMENT_REPORT_REQUEST = '@reports/PAYMENT_REPORT_REQUEST',
  PAYMENT_REPORT_SUCCESS = '@reports/PAYMENT_REPORT_SUCCESS',
  PAYMENT_REPORT_FAILURE = '@reports/PAYMENT_REPORT_FAILURE',

  EMTU_REPORT_REQUEST = '@reports/EMTU_REPORT_REQUEST',
  EMTU_REPORT_SUCCESS = '@reports/EMTU_REPORT_SUCCESS',
  EMTU_REPORT_FAILURE = '@reports/EMTU_REPORT_FAILURE',

  GENERAL_REPORT_REQUEST = '@reports/GENERAL_REPORT_REQUEST',
  GENERAL_REPORT_SUCCESS = '@reports/GENERAL_REPORT_SUCCESS',
  GENERAL_REPORT_FAILURE = '@reports/GENERAL_REPORT_FAILURE',

  TRAVEL_BY_LINE_REPORT_REQUEST = '@reports/TRAVEL_BY_LINE_REPORT_REQUEST',
  TRAVEL_BY_LINE_REPORT_SUCCESS = '@reports/TRAVEL_BY_LINE_REPORT_SUCCESS',
  TRAVEL_BY_LINE_REPORT_FAILURE = '@reports/TRAVEL_BY_LINE_REPORT_FAILURE',

  GET_PASSENGERS_AND_VEHICLES_REPORT_REQUEST = '@reports/GET_PASSENGERS_AND_VEHICLES_REPORT_REQUEST',
  GET_PASSENGERS_AND_VEHICLES_REPORT_SUCCESS = '@reports/GET_PASSENGERS_AND_VEHICLES_REPORT_SUCCESS',
  GET_PASSENGERS_AND_VEHICLES_REPORT_FAILURE = '@reports/GET_PASSENGERS_AND_VEHICLES_REPORT_FAILURE',

  GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT_REQUEST = '@reports/GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT_REQUEST',
  GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT_SUCCESS = '@reports/GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT_SUCCESS',
  GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT_FAILURE = '@reports/GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT_FAILURE',

  GET_PEDESTRIAN_ENTRY_BY_TERMINAL_REPORT_REQUEST = '@reports/GET_PEDESTRIAN_ENTRY_BY_TERMINAL_REPORT_REQUEST',
  GET_PEDESTRIAN_ENTRY_BY_TERMINAL_REPORT_SUCCESS = '@reports/GET_PEDESTRIAN_ENTRY_BY_TERMINAL_REPORT_SUCCESS',
  GET_PEDESTRIAN_ENTRY_BY_TERMINAL_REPORT_FAILURE = '@reports/GET_PEDESTRIAN_ENTRY_BY_TERMINAL_REPORT_FAILURE',

  GET_TIMED_OUT_ENTRIES_REPORT_REQUEST = '@reports/GET_TIMED_OUT_ENTRIES_REPORT_REQUEST',
  GET_TIMED_OUT_ENTRIES_REPORT_SUCCESS = '@reports/GET_TIMED_OUT_ENTRIES_REPORT_SUCCESS',
  GET_TIMED_OUT_ENTRIES_REPORT_FAILURE = '@reports/GET_TIMED_OUT_ENTRIES_REPORT_FAILURE',

  CREATE_CHIPS_PAYMENT_REPORT = '@reports/CREATE_CHIPS_PAYMENT_REPORT',
  CLEAN_CHIPS_PAYMENT_REPORT = '@reports/CLEAN_CHIPS_PAYMENT_REPORT',

  SET_SELECTED_CARS_ID = '@reports/SET_SELECTED_CARS_ID',
  SET_SELECTED_INVOICE_STATUS = '@reports/SET_SELECTED_INVOICE_STATUS',
  SET_SELECTED_CARS = '@reports/SET_SELECTED_CARS',
  SET_SELECTED_TERMINALS = '@reports/SET_SELECTED_TERMINALS',
  SET_SELECTED_PROFILES = '@reports/SET_SELECTED_PROFILES',
  SET_SELECTED_PAYMENTS = '@reports/SET_SELECTED_PAYMENTS',
  SET_SELECTED_PAYMENT_STATUS = '@reports/SET_SELECTED_PAYMENT_STATUS',
  SET_SELECTED_OPERATION_TYPE = '@reports/SET_SELECTED_OPERATION_TYPE',
  SET_SELECTED_QRCODES = '@reports/SET_SELECTED_QRCODES',
  SET_SELECTED_LINES = '@reports/SET_SELECTED_LINES',
  SET_SELECTED_SCHOOLS = '@reports/SET_SELECTED_SCHOOLS',
  SET_SELECTED_EMVTYPE = '@reports/SET_SELECTED_EMVTYPE',
  SET_SELECTED_BRAND = '@reports/SET_SELECTED_BRAND',
  SET_SELECTED_SECTION_LINES = '@reports/SET_SELECTED_SECTION_LINES',
  SET_SELECTED_START_DATE = '@reports/SELECTED_START_DATE',
  SET_SELECTED_PROFILE_EXPIRATION = '@reports/SET_SELECTED_PROFILE_EXPIRATION',
  SET_SELECTED_STARTED_AT_DATE = '@reports/SELECTED_STARTED_AT_DATE',
  SET_SELECTED_NUMBER_OF_DAYS = '@reports/SET_SELECTED_NUMBER_OF_DAYS',
  SET_SELECTED_END_DATE = '@reports/SELECTED_END_DATE',
  SET_SELECTED_EMPLOYEES = '@reports/SET_SELECTED_EMPLOYEES',
  SET_SELECTED_DRIVER_REGISTRY = '@reports/SET_SELECTED_DRIVER_REGISTRY',
  SET_SELECTED_RECEIVE_PAYMENTS = '@reports/SET_SELECTED_RECEIVE_PAYMENTS',
  SET_SELECTED_TRIP_STATUS = '@reports/SET_SELECTED_TRIP_STATUS',
  SET_SELECTED_TRIP_OR_TICKET = '@reports/SET_SELECTED_TRIP_OR_TICKET',
  SET_SELECTED_SUPERVISOR = '@reports/SET_SELECTED_SUPERVISOR',
  SET_SELECTED_DBD = '@reports/SET_SELECTED_DBD',
  SET_SELECTED_TOKEN_STATUS = '@reports/SET_SELECTED_TOKEN_STATUS',
  SET_SELECTED_CREDIT_TYPE = '@reports/SET_SELECTED_CREDIT_TYPE',
  SET_SELECTED_SELLING_POINT = '@reports/SET_SELECTED_SELLING_POINT',
  SET_SELECTED_SELLING_TERMINAL = '@reports/SET_SELECTED_SELLING_TERMINAL',
  SET_SECCIONED_LINES = '@reports/SET_SECCIONED_LINES',
  SET_SELECTED_DATE_TYPE = '@reports/SET_SELECTED_DATE_TYPE',
  SET_SELECTED_LINE_TYPE = '@reports/SET_SELECTED_LINE_TYPE',
  SET_STATUS_DEVICE_RELEASE = '@reports/SET_STATUS_DEVICE_RELEASE',
  SET_SELECTED_DATE_TYPE_BPE = '@reports/SET_SELECTED_DATE_TYPE_BPE',

  SET_SELECTED_ID = '@reports/SET_SELECTED_ID',
  SET_SELECTED_NAME = '@reports/SET_SELECTED_NAME',
  SET_SELECTED_BPE_CODE = '@reports/SET_SELECTED_BPE_CODE',
  SET_SELECTED_BPE_NUMBER = '@reports/SET_SELECTED_BPE_NUMBER',
  SET_SELECTED_INCLUDE_BPE = '@reports/SET_SELECTED_INCLUDE_BPE',
  SET_SELECTED_ORIGIN = '@reports/SET_SELECTED_ORIGIN',
  SET_SELECTED_DESTINY = '@reports/SET_SELECTED_DESTINY',
  SET_SELECTED_LINE_SECTION_NAME = '@reports/SET_SELECTED_LINE_SECTION_NAME',
  SET_SELECTED_BENEFIT = '@reports/SET_SELECTED_BENEFIT',
  SET_SELECTED_QUANTITY = '@reports/SET_SELECTED_QUANTITY',
  SET_SELECTED_DOCUMENT = '@reports/SET_SELECTED_DOCUMENT',
  SET_SELECTED_EMAIL = '@reports/SET_SELECTED_EMAIL',
  SET_SELECTED_TRANSPORT_CARD = '@reports/SET_SELECTED_TRANSPORT_CARD',
  SET_SELECTED_DEVICE = '@reports/SET_SELECTED_DEVICE',
  SET_SELECTED_CREDIT_CARD = '@reports/SET_SELECTED_CREDIT_CARD',
  SET_SELECTED_PROFILE_STATUS = '@reports/SET_SELECTED_PROFILE_STATUS',
  SET_SELECTED_STATUS = '@reports/SET_SELECTED_STATUS',
  SET_SELECTED_CNPJ = '@reports/SET_SELECTED_CNPJ',
  SET_SELECTED_NSU = '@reports/SET_SELECTED_NSU',
  SET_SELECTED_PHONE = '@reports/SET_SELECTED_PHONE',
  SET_HISTORY_FILTER = '@reports/SET_HISTORY_FILTER',
  SET_SELECTED_LICENSE = '@reports/SET_SELECTED_LICENSE',
  SET_SELECTED_PREFIX = '@reports/SET_SELECTED_PREFIX',
  SET_SELECTED_CAR_MODEL = '@reports/SET_SELECTED_CAR_MODEL',
  SET_SELECTED_AGE = '@reports/SET_SELECTED_AGE',
  SET_SELECTED_SIT_CAPACITY = '@reports/SET_SELECTED_SIT_CAPACITY',
  SET_SELECTED_FOOT_CAPACITY = '@reports/SET_SELECTED_FOOT_CAPACITY',
  SET_SELECTED_ACCESSIBLE = '@reports/SET_SELECTED_ACCESSIBLE',
  SET_SELECTED_AIR_CONDITIONED = '@reports/SET_SELECTED_AIR_CONDITIONED',
  SET_SELECTED_TICKETER = '@reports/SET_SELECTED_TICKETER',
  SET_SELECTED_REGISTRY = '@reports/SET_SELECTED_REGISTRY',
  SET_SELECTED_LICENSE_NUMBER = '@reports/SET_SELECTED_LICENSE_NUMBER',
  SET_SELECTED_NUMBER = '@reports/SET_SELECTED_NUMBER',
  SET_SELECTED_CARD_NUMBER = '@reports/SET_SELECTED_CARD_NUMBER',
  SET_SELECTED_LOT = '@reports/SET_SELECTED_LOT',
  SET_SELECTED_CARD_TYPE = '@reports/SET_SELECTED_CARD_TYPE',
  SET_SELECTED_CARD_STATUS = '@reports/SET_SELECTED_CARD_STATUS',
  SET_SELECTED_TITLE = '@reports/SET_SELECTED_TITLE',
  SET_SELECTED_LINE_MODES = '@reports/SET_SELECTED_LINE_MODES',
  SET_SELECTED_LINE_MODEL = '@reports/SET_SELECTED_LINE_MODEL',
  SET_SELECTED_COVERED = '@reports/SET_SELECTED_COVERED',
  SET_SELECTED_BUS_BAY = '@reports/SET_SELECTED_BUS_BAY',
  SET_SELECTED_SPECIAL_BUS_STOP = '@reports/SET_SELECTED_SPECIAL_BUS_STOP',
  SET_SELECTED_RESPONSIBLE = '@reports/SET_SELECTED_RESPONSIBLE',
  SET_SELECTED_BLOCK_NAME = '@reports/SET_SELECTED_BLOCK_NAME',
  SET_SELECTED_TERMINAL_NAME = '@reports/SET_SELECTED_TERMINAL_NAME',
  SET_SELECTED_TOTAL_LINES = '@reports/SET_SELECTED_TOTAL_LINES',
  SET_SELECTED_TARIFF = '@reports/SET_SELECTED_TARIFF',

  SET_FILTERED_ITEMS = '@reports/SET_FILTERED_ITEMS',

  SET_CSV_FULL_IS_CHECKED = '@reports/SET_CSV_FULL_IS_CHECKED',

  SET_SELECTED_DOCUMENT_TYPE = '@reports/SET_SELECTED_DOCUMENT_TYPE',

  SHEDULE_LIST_REQUEST = '@reports/SHEDULE_LIST_REQUEST',
  SECOND_SHEDULE_LIST_REQUEST = '@reports/SECOND_SHEDULE_LIST_REQUEST',
  SHEDULE_LIST_SUCCESS = '@reports/SHEDULE_LIST_SUCCESS',
  SECOND_SHEDULE_LIST_SUCCESS = '@reports/SECOND_SHEDULE_LIST_SUCCESS',
  SHEDULE_LIST_FAILURE = '@reports/SHEDULE_LIST_FAILURE',
  SECOND_SHEDULE_LIST_FAILURE = '@reports/SECOND_SHEDULE_LIST_FAILURE',

  SHEDULE_DELETE_REQUEST = '@reports/SHEDULE_DELETE_REQUEST',
  SHEDULE_DELETE_SUCCESS = '@reports/SHEDULE_DELETE_SUCCESS',
  SHEDULE_DELETE_FAILURE = '@reports/SHEDULE_DELETE_FAILURE',

  SHEDULE_CREATE_REQUEST = '@reports/SHEDULE_CREATE_REQUEST',
  SHEDULE_CREATE_SUCCESS = '@reports/SHEDULE_CREATE_SUCCESS',
  SHEDULE_CREATE_FAILURE = '@reports/SHEDULE_CREATE_FAILURE',

  SHEDULE_UPDATE_REQUEST = '@reports/SHEDULE_UPDATE_REQUEST',
  SHEDULE_UPDATE_SUCCESS = '@reports/SHEDULE_UPDATE_SUCCESS',
  SHEDULE_UPDATE_FAILURE = '@reports/SHEDULE_UPDATE_FAILURE',

  SHEDULE_SUCCESS = '@reports/SHEDULE_SUCCESS',

  PAYMENT_REQUEST_LIST_REQUEST = '@reports/PAYMENT_REQUEST_LIST_REQUEST',
  PAYMENT_REQUEST_LIST_SUCCESS = '@reports/PAYMENT_REQUEST_LIST_SUCCESS',
  PAYMENT_REQUEST_LIST_FAILURE = '@reports/PAYMENT_REQUEST_LIST_FAILURE',

  SET_SELECTED_FILENAME = '@companyReport/SET_SELECTED_FILENAME',

  SHIPMENT_BY_LINE_REQUEST = '@reports/SHIPMENT_BY_LINE_REQUEST',
  SHIPMENT_BY_LINE_SUCCESS = '@reports/SHIPMENT_BY_LINE_SUCCESS',
  SHIPMENT_BY_LINE_FAILURE = '@reports/SHIPMENT_BY_LINE_FAILURE',

  INCOMING_BY_KM_VALUE_REPORT_REQUEST = '@reports/INCOMING_BY_KM_VALUE_REPORT_REQUEST',
  INCOMING_BY_KM_VALUE_REPORT_SUCCESS = '@reports/INCOMING_BY_KM_VALUE_REPORT_SUCCESS',
  INCOMING_BY_KM_VALUE_REPORT_FAILURE = '@reports/INCOMING_BY_KM_VALUE_REPORT_FAILURE',

  SET_SELECTED_INCOMING_TYPES = '@companyReport/SET_SELECTED_INCOMING_TYPES',

  TRIP_COLLECTION_REPORT_REQUEST = '@reports/TRIP_COLLECTION_REPORT_REQUEST',
  TRIP_COLLECTION_REPORT_SUCCESS = '@reports/TRIP_COLLECTION_REPORT_SUCCESS',
  TRIP_COLLECTION_REPORT_FAILURE = '@reports/TRIP_COLLECTION_REPORT_FAILURE',

  EMV_REPORT_REQUEST = '@reports/EMV_REPORT_REQUEST',
  EMV_REPORT_SUCCESS = '@reports/EMV_REPORT_SUCCESS',
  EMV_REPORT_FAILURE = '@reports/EMV_REPORT_FAILURE',

  BPE_REPORT_REQUEST = '@reports/BPE_REPORT_REQUEST',
  BPE_REPORT_SUCCESS = '@reports/BPE_REPORT_SUCCESS',
  BPE_REPORT_FAILURE = '@reports/BPE_REPORT_FAILURE',

  BPE_TAX_VERIFICATION_REPORT_REQUEST = '@reports/BPE_TAX_VERIFICATION_REPORT_REQUEST',
  BPE_TAX_VERIFICATION_REPORT_SUCCESS = '@reports/BPE_TAX_VERIFICATION_REPORT_SUCCESS',
  BPE_TAX_VERIFICATION_REPORT_FAILURE = '@reports/BPE_TAX_VERIFICATION_REPORT_FAILURE',

  EMV_DECLINED_BY_REASON_REQUEST = '@reports/EMV_DECLINED_BY_REASON_REQUEST',
  EMV_DECLINED_BY_REASON_SUCCESS = '@reports/EMV_DECLINED_BY_REASON_SUCCESS',
  EMV_DECLINED_BY_REASON_FAILURE = '@reports/EMV_DECLINED_BY_REASON_FAILURE',

  EMV_APPROVED_BY_BRAND_REQUEST = '@reports/EMV_APPROVED_BY_BRAND_REQUEST',
  EMV_APPROVED_BY_BRAND_SUCCESS = '@reports/EMV_APPROVED_BY_BRAND_SUCCESS',
  EMV_APPROVED_BY_BRAND_FAILURE = '@reports/EMV_APPROVED_BY_BRAND_FAILURE',

  EMV_APPROVED_BY_DEBT_RECOVERY_REQUEST = '@reports/EMV_APPROVED_BY_DEBT_RECOVERY_REQUEST',
  EMV_APPROVED_BY_DEBT_RECOVERY_SUCCESS = '@reports/EMV_APPROVED_BY_DEBT_RECOVERY_SUCCESS',
  EMV_APPROVED_BY_DEBT_RECOVERY_FAILURE = '@reports/EMV_APPROVED_BY_DEBT_RECOVERY_FAILURE',

  EMV_APPROVED_BY_ATTEMPTS_REQUEST = '@reports/EMV_APPROVED_BY_ATTEMPTS_REQUEST',
  EMV_APPROVED_BY_ATTEMPTS_SUCCESS = '@reports/EMV_APPROVED_BY_ATTEMPTS_SUCCESS',
  EMV_APPROVED_BY_ATTEMPTS_FAILURE = '@reports/EMV_APPROVED_BY_ATTEMPTS_FAILURE',

  EMV_APPROVED_FIRST_TAP_BY_BRAND_REQUEST = '@reports/EMV_APPROVED_FIRST_TAP_BY_BRAND_REQUEST',
  EMV_APPROVED_FIRST_TAP_BY_BRAND_SUCCESS = '@reports/EMV_APPROVED_FIRST_TAP_BY_BRAND_SUCCESS',
  EMV_APPROVED_FIRST_TAP_BY_BRAND_FAILURE = '@reports/EMV_APPROVED_FIRST_TAP_BY_BRAND_FAILURE',

  EMV_ENTRY_GET_REQUEST = '@reports/EMV_ENTRY_GET_REQUEST',
  EMV_ENTRY_GET_SUCCESS = '@reports/EMV_ENTRY_GET_SUCCESS',
  EMV_ENTRY_GET_FAILURE = '@reports/EMV_ENTRY_GET_FAILURE',

  EMV_ENTRY_GET_HISTORY_REQUEST = '@reports/EMV_ENTRY_GET_HISTORY_REQUEST',
  EMV_ENTRY_GET_HISTORY_SUCCESS = '@reports/EMV_ENTRY_GET_HISTORY_SUCCESS',
  EMV_ENTRY_GET_HISTORY_FAILURE = '@reports/EMV_ENTRY_GET_HISTORY_FAILURE',

  ORDERS_BY_SCHOOL_REPORT_REQUEST = '@reports/ORDERS_BY_SCHOOL_REPORT_REQUEST',
  ORDERS_BY_SCHOOL_REPORT_SUCCESS = '@reports/ORDERS_BY_SCHOOL_REPORT_SUCCESS',
  ORDERS_BY_SCHOOL_REPORT_FAILURE = '@reports/ORDERS_BY_SCHOOL_REPORT_FAILURE',

  STUDENT_CARDS_REPORT_REQUEST = '@reports/STUDENT_CARDS_REPORT_REQUEST',
  STUDENT_CARDS_REPORT_SUCCESS = '@reports/STUDENT_CARDS_REPORT_SUCCESS',
  STUDENT_CARDS_REPORT_FAILURE = '@reports/STUDENT_CARDS_REPORT_FAILURE',

  TRIP_CONTROL_DETAIL_RESUME_REPORT_REQUEST = '@reports/TRIP_CONTROL_DETAIL_RESUME_REPORT_REQUEST',
  TRIP_CONTROL_DETAIL_RESUME_REPORT_SUCCESS = '@reports/TRIP_CONTROL_DETAIL_RESUME_REPORT_SUCCESS',
  TRIP_CONTROL_DETAIL_RESUME_REPORT_FAILURE = '@reports/TRIP_CONTROL_DETAIL_RESUME_REPORT_FAILURE',

  PROFILE_BY_AGE_ROUPE_REPORT_REQUEST = '@reports/PROFILE_BY_AGE_ROUPE_REPORT_REQUEST',
  PROFILE_BY_AGE_ROUPE_REPORT_SUCCESS = '@reports/PROFILE_BY_AGE_ROUPE_REPORT_SUCCESS',
  PROFILE_BY_AGE_ROUPE_REPORT_FAILURE = '@reports/PROFILE_BY_AGE_ROUPE_REPORT_FAILURE',

  SET_SELECTED_EMV_STATUS = '@facial/SET_SELECTED_EMV_STATUS',

  CREDITIS_BY_SCHOOL_REPORT_REQUEST = '@reports/CREDITIS_BY_SCHOOL_REPORT_REQUEST',
  CREDITIS_BY_SCHOOL_REPORT_SUCCESS = '@reports/CREDITIS_BY_SCHOOL_REPORT_SUCCESS',
  CREDITIS_BY_SCHOOL_REPORT_FAILURE = '@reports/CREDITIS_BY_SCHOOL_REPORT_FAILURE',

  USAGE_STATISTICS_REPORT_REQUEST = '@reports/USAGE_STATISTICS_REPORT_REQUEST',
  USAGE_STATISTICS_REPORT_SUCCESS = '@reports/USAGE_STATISTICS_REPORT_SUCCESS',
  USAGE_STATISTICS_REPORT_FAILURE = '@reports/USAGE_STATISTICS_REPORT_FAILURE',

  GRATUITIES_REPORT_REQUEST = '@reports/GRATUITIES_REPORT_REQUEST',
  GRATUITIES_REPORT_SUCCESS = '@reports/GRATUITIES_REPORT_SUCCESS',
  GRATUITIES_REPORT_FAILURE = '@reports/GRATUITIES_REPORT_FAILURE',

  GET_TRIP_REQUEST = '@reports/GET_TRIP_REQUEST',

  SET_SELECTED_SHOOL_CODE = '@reports/SET_SELECTED_SHOOL_CODE',

  SET_SELECTED_SHOOL_TYPE = '@reports/SET_SELECTED_SHOOL_TYPE',

  SET_IS_SEARCH_ACTIVE = '@reports/SET_IS_SEARCH_ACTIVE',

  SET_SELECTED_COMPANIES = '@reports/SET_SELECTED_COMPANIES',

  EXTERNAL_REPORTS = '@reports/EXTERNAL_REPORTS',

  EMPLOYEE_TRIP_SAP_RESUME_REPORT_REQUEST = '@reports/EMPLOYEE_TRIP_SAP_RESUME_REPORT_REQUEST',
  EMPLOYEE_TRIP_SAP_RESUME_REPORT_SUCCESS = '@reports/EMPLOYEE_TRIP_SAP_RESUME_REPORT_SUCCESS',
  EMPLOYEE_TRIP_SAP_RESUME_REPORT_FAILURE = '@reports/EMPLOYEE_TRIP_SAP_RESUME_REPORT_FAILURE',

  SET_SELECTED_PAYMENT_DAY = '@reports/SET_SELECTED_PAYMENT_DAY',
}

/*
 * Data types
 */
interface LineSectionInterface extends LineSectionBaseInterface {
  Fare: FareInterface;
  Line: LineInterface;
}

export interface DbdEmvEntryInterface {
  id: string;
  createdAt: string;
  updatedAt: string;
  entryId: string;
}

export interface DbdTokenEntryInterface {
  id: string;
  createdAt: string;
  updatedAt: string;
  tokenId: string;
  entryId: string;
  Token?: TokenInterface;
}

export interface DbdButtonEntryInterface {
  id: string;
  createdAt: string;
  updatedAt: string;
  entryId: string;
}

export interface DbdExternEntryInterface {
  id: string;
  createdAt: string;
  updatedAt: string;
  entryId: string;
}

export interface EntryInterface {
  id: string;
  value: number;
  createdAt: string;
  updatedAt: string;
  usedAt: string;
  dbdId: string;
  latitude: number;
  longitude: number;
  lineSectionId: string;
  benefitId?: string;
  lineMatrixIntegrationId?: string;
  LineSection?: LineSectionInterface;
  Dbd?: DbdInterface;
  DbdEmvEntry?: DbdEmvEntryInterface;
  DbdTokenEntry?: DbdTokenEntryInterface;
  DbdButtonEntry?: DbdButtonEntryInterface;
  DbdExternEntry?: DbdExternEntryInterface;
  DbdTransportCardEntry?: TransportCardEntryInterface;
}

export interface EntrySimplifiedInterface {
  id: string;
  usageType: string;
  line: string;
  dbd: string;
  lat: number;
  lng: number;
  benefit: string;
  createdAt: string;
  value: string;
  place: string;
  description: string;
}

export interface ScheduleInterface {
  id?: string;
  reportType: string;
  title: string;
  status: number;
  supervisorIds: string[];
  filters: object;
  groupings: string[];
  frequencyType: number;
  frequencyHour: string;
  frequencyWeekday: string[];
  frequencyQuantity: number;
  frequencyMonthday: string;
  frequencyMonth: string;
  repeatUntil: {
    type: number;
    value: number;
  } | null;
  dataInterval: number;
  formats: string[];
  createdAt?: string;
  updatedAt?: string;
  ReportScheduleHistories?: ReportScheduleHistoriesInterface[];
}
export interface ReportScheduleHistoriesInterface {
  id: string;
  title: string;
  success: boolean;
  supervisorIds: string[];
  filters: object;
  groupings: string[];
  repeatUntil: {
    type: number;
    value: number;
  } | null;
  dataInterval: number;
  formats: string[];
  createdAt: string;
  updatedAt: string;
  reportScheduleId: string;
}
export interface scheduleDeleteInterface {
  result: boolean;
}

export interface SuperiorAccessReportInterface {
  [key: string]: EntrySimplifiedInterface[];
}

export interface TransportCardEntryInterface {
  id: string;
  createdAt: string;
  updatedAt: string;
  transportCardId: string;
  entryId: string;
  TransportCard?: TransportCardInterface;
  Entry?: EntryInterface;
}

export interface EntryGroupedInterface {
  count: number;
  totalValue: number;
  usedDate: string;
  dbdId: string;
  paymentType: number;
}

export interface ChartReportInterface {
  value: number;
  date: string;
}

export interface ChartEntryReportInterface {
  totalValue: number;
  data: EntryInterface[];
}

export interface LineDemandReportInterface {
  [key: string]: {
    valuePerKm: number;
    totalValue?: number;
    ipk: number;
    ipke: number;
    kvd: number;
    pvd: number;
    kpis: {
      ipk: number;
      ipke: number;
      valuePerKm: number;
      kvd: number;
      pvd: number;
      km: number;
      idleKm: number;
      trips: number;
    };
    benefits: object;
    benefitsCount: object;
  };
}

export interface DailyDemandReportInterface {
  [key: string]: {
    totalValue?: number;
    kpis: {
      km: number;
      idleKm: number;
      trips: number;
      cars: number;
      ipk: number;
      ipke: number;
      valuePerKm: number;
      kvd: number;
      pvd: number;
    };
    benefits: object;
    benefitsCount: object;
  };
}

export interface ChipsInterface {
  key: number;
  label: string;
  filter: object;
}

export interface HeatmapInterface {
  lat: number;
  lng: number;
}

export interface PaymentInterface {
  id: string;
  value: number;
  date: string;
  from: string;
  to: string;
  type: string;
  transportOperatorId?: string;
}

export interface SelectedCarInterface {
  id: string;
  license: string;
}

export interface SelectedTerminalInterface {
  id: string;
  name: string;
}

export interface SelectedProfilesInterface {
  id: string;
  name: string;
}

export interface SelectedPaymentsInterface {
  key: string;
  value: string;
}

export interface SelectedPaymentStatusInterface {
  key: number;
  value: string;
}

export interface SelectedOperationTypeInterface {
  key: number;
  value: string;
}

export interface SelectedQRcodesInterface {
  key: number;
  value: string;
}

export interface SelectedTokenStatus {
  key: string | number;
  value: string;
}

export interface SelectedCreditType {
  key: number;
  value: string;
}
export interface SelectedLinesInterface extends SelectedProfilesInterface {}

export interface SelectedEmployeesInterface extends SelectedProfilesInterface {}

export interface SelectedDriverRegistryInterface extends SelectedProfilesInterface {}
export interface SelectedReceivePaymentsInterface
  extends SelectedPaymentsInterface {}

export interface SelectedSupervisorInterface
  extends SelectedProfilesInterface {}

export interface SelectedDbdInterface extends DbdInterface {}

export interface EmtuReportMonthInterface {
  month: string;
  buys: number;
  usages: number;
  buyValue: number;
  usageValue: number;
}

export interface EmtuReportDataInterface {
  user: string;
  balance: number;
  monthsResult: EmtuReportMonthInterface[];
  transportOperatorId?: string;
}

export interface EmtuReportInterface {
  data: EmtuReportDataInterface[];
  csv: string;
}

export interface GeneralReportInterface {
  Data: string;
  TotalGeral: number;
  Pagantes: number;
  Integracoes: number;
  Gratuito: number;
  Funcionario: number;
  Est50: number;
  EstGratuito: number;
  Fiscal: number;
  Comum: number;
  VT: number;
  'Tot.Eco.': number;
  'Eco.Eqv.': number;
  TotalGrat: number;
  'Tot Eco': number;
  'Eco. Eqv.': number;
  'Total Grat': number;
}

export interface TravelByLineInterface {
  name: string;
  totalKm: number;
  prefix: string;
  trips: number;
  color: string;
  transportOperatorId?: string;
}

export interface FilterItems {
  key: string;
  value: string | number | null;
}

export interface PaymentRequestInterface {
  id: string;
  value: number;
  status: number;
  createdAt: string;
  name: string;
  type: string;
  transportOperatorId?: string;
}

export interface ShipmentByLineInterface {
  [id: string]: {
    [date: string]: {
      total: number | any; // using any for bypass
      [hour: string]: {
        [point: string]: number;
      };
    };
  };
}

export interface DataTypeKmPerDayReport {
  title: string;
  value: number;
}

export interface KmPerDayReportInterface {
  title: string;
  data: DataTypeKmPerDayReport[];
}

export interface TransportedPassengersInterface {
  year: string;
  JAN: number;
  FEV: number;
  MAR: number;
  ABR: number;
  MAI: number;
  JUN: number;
  JUL: number;
  AGO: number;
  SET: number;
  OUT: number;
  NOV: number;
  DEZ: number;
  total?: number;
  average?: number;
}

export interface TransportedPassengersByTimeFrame {
  id?: number;
  hour?: string;
  bonus?: boolean;
  days: Day[];
  total?: boolean;
  totalIds?: number[];
}

export interface TransportedPassengersByTimeFrameByProfile {
  id?: number;
  hour?: string;
  bonus?: boolean;
  profiles: Day[];
  total?: boolean;
  totalIds?: number[];
}

export interface Day {
  title: string;
  value?: number;
}

export interface IncomingByKmValueReportInterface {
  date: string;
  totalTransactions: number;
  km: number;
  totalKmPrice: number;
  kmPrice: number;
  result: number;
  sellingTransactions?: {
    value: number;
    data: {
      value: number;
      responsible: string;
      place: string;
    }[];
  };
  employeeTransactions?: {
    value: number;
    data: {
      value: number;
      responsible: string;
      place: string;
    }[];
  };
  vtUsersTransactions?: {
    value: number;
    data: {
      value: number;
      responsible: string;
      place?: string;
    }[];
  };
}

export interface SelectedReportTypesInterface {
  KEY: string;
  VALUE: string;
}
// Interface used in PathAutocomete
export interface SectionData extends SectionInterface {
  Line: {
    id: string;
    name: string;
    prefix: string;
    color: string;
    transportOperatorId: string;
  };
}

export interface ValueTripCollectionReport {
  title: string;
  value: string | null;
}

export interface TripCollectionReportInterface {
  title: string;
  values: ValueTripCollectionReport[];
  empty?: boolean | null;
}

export interface InvoiceInterface {
  id: string;
  invoicepdf?: string;
  status: number;
  value: number;
  description: string;
  type: string;
  createdAt: Date;
  updatedAt: Date;
  transportOperatorId: string;
  data?: any;
}

export interface SimpleProfile {
  name: string;
  lineSections?: SimpleProfile[];
  quantity: number;
  total: number;
  fare?: number;
}

export interface PassengersByOrigin {
  location: string;
  profiles: SimpleProfile[];
  quantity: number;
  total: number;
}

export interface emvReportInterface {
  createdAt: string;
  brand: string;
  type: string;
  card: string;
  message: string;
  id: string;
  transportOperatorId: string;
  value: number;
  status: boolean;
}
export interface TripControlLinesInterface {
  tripId: string;
  employeeName: string;
  employeeId: string;
  line: string;
  startedAt: string;
  closedAt: string;
  audit: {
    startEntryCount: number; // Catraca Entrada Inicial - Motorista
    startEntryCountPhoto: string;
    endEntryCount: number; // Catraca Entrada Final - Motorista
    endEntryCountPhoto: string;
    resultEntryCount: number; // Total Giros - Motorista
    rollsEntryCount: number | null; // Registro DBD
    diffEntryCount: number | null; // Diferenca

    startExitCount: number; // Catraca Saida Inicial - Motorista
    startExitCountPhoto: string;
    endExitCount: number; // Catraca Saida Final - Motorista
    endExitCountPhoto: string;
    resultExitCount: number; // Total Giros Saida - Motorista
    rollsExitCount: number | null; // Registro DBD
    diffExitCount: number | null; // Diferenca
  };
}
export interface TripControlDetailResume {
  car: string;
  lines: TripControlLinesInterface[];
}

export interface UsageStatisticsInterface {
  range: string;
  quantity: number;
  percentage: number;
}

export interface CreditisBySchoolListInterface {
  type: string | number;
  data:
    | {
        type: string;
        quantity: number;
        students: number;
        usages: number;
        percentage: string;
      }[]
    | { name: string; code: string; quantity: number; usage: number }[];
}

export interface ProfileByAgeGroupListInterface {
  title: string | number;
  data: {
    usages: number;
    users: number;
    title: string;
  }[];
}

export interface EmvDeclinedByReasonInterface {
  message: string;
  occurrencies: number;
  percentage: number;
}

export interface EmvApprovedByBrandInterface {
  brand: string;
  approved: number;
  declined: number;
  total: number;
  approvalPercentage: string;
}

export interface EmvApprovedByDebtRecoveryInterface {
  brand: string;
  attempts: number;
  approvalDebtRecovery: number;
  percentage: number;
}

export interface EmvApprovedByAttemptsInterface {
  cnt: number;
  total: number;
  percentage: number;
  brands: Brand[];
}

export interface Brand {
  cnt: number;
  brand: string;
  total: number;
}

export interface EmvApprovedByFirstTapByBrandInterface {
  brand: string;
  totalApproved: number;
  approvedFirstTap: number;
  approvalPercentage: string;
}

export interface EmvEntryGetInterface {
  id: string;
  number: string;
  timeout: boolean;
  usedAt: Date;
  latitude: number;
  longitude: number;
  line: LineInterface;
  place: string;
}

export interface EmvEntryGetHistoryInterface {
  id: string;
  transactionId: string;
  paymentId: string | null;
  message: string | null;
  type: string;
  approved: boolean;
  nextAttempt?: Date;
  debitRecovery: boolean;
  tapRecovery: boolean;
  brand: string;
  card: string;
  nsu: string | null;
  createdAt: Date;
  attempts?: EmvEntryGetHistoryInterface[];
}

export interface Profile {
  name?: string;
  passengers: number;
  value: number;
}

export interface Row {
  date: string;
  profiles: Profile[];
  vehicles: Profile[];
  total: Profile[];
}

export interface ItemInterface {
  tripScheduleId: string;
  tripOpen: string;
  tripEnd: string;
  lineSectionName: string;
  carPrefix: string;
  profiles: Profile[];
  vehicles: Profile[];
  total: Profile[];
}

export interface RowByTrip {
  date: string;
  items: ItemInterface[];
}

export interface PassengersAndVehiclesReportInterface {
  columns: string[];
  rows: Row[];
}

export interface PassengersAndVehiclesByTripReportInterface {
  columns: string[];
  rows: RowByTrip[];
}

export interface PedestriansEntryByTerminalInterface {
  name: string;
  open: number | string;
  paying: any;
  nonPaying: any;
  type?: number;
  payingTotal: number;
  nonPayingTotal: number;
  total: number;
}

export interface OrdersBySchoolInterface {
  name: string;
  dates: DateElement[];
}

export interface DateElement {
  date: string;
  orders: Order[];
}

export interface Order {
  id: string;
  students: Student[];
  subtotal: number;
}

export interface ExternalReportsInterface {
  additionalId: string;
  url: string;
  title: string;
}

export interface CarList {
  [key: string]: {
    datahora: string;
    frota: string;
    lat: string;
    lon: string;
    codlinha: string;
    carId: string;
  }[];
}
export interface Student {
  card: string;
  type: string;
  name: string;
  document: string;
  total: number;
  releaseDate: string;
  status: string;
}

export interface StudentInterface {
  userId: string;
  userName: string;
  shortId: string;
  phone: string;
  schoolId: string;
  school: string;
  deviceId: string;
  device: string;
  fileName?: string;
  schoolRegistry?: string;
}

export interface StudentCardListInterface {
  school: string;
  registers: {
    news: StudentInterface[];
    updateds: StudentInterface[];
  };
}

export interface InterfaceBpeReportList {
  userName?: string | null;
  userDoc?: string | null;
  tripStartedAt?: string | null; // ou Date se for convertido
  tripId?: string | null;
  employeeName?: string | null;
  carLicense?: string | null;
  entryUsedAt?: string | null;
  exitUsedAt?: string | null;
  cityOrigin?: string | null;
  cityDestiny?: string | null;
  lineSectionName?: string | null;
  carPrefix?: string | null;
  bpeNumber?: number | null;
  bpeCode?: string | null;
  bpeCreatedAt?: string | null;
  benefitName?: string | null;
  bpeIssueDateTime?: number | null;
  bpeSerie?: string | null;
  bpeModality?: string | null;
  bpeServiceType?: string | null;
  icmsBase?: number | null;
  icmsValue?: number | null;
  bpePaymentMethods?: string | null;
  bpePaymentValue?: string | null;
  hasDisability?: boolean | null;
  freeDisabilityValue?: string | null;
  isElderly?: boolean | null;
  freeElderValue?: string | null;
  paidValue?: string | null;
  ticketValue?: string | null;
}

export interface InterfaceBpeTaxVerificationReportList {
  bpeCode?: string | null;
  bpeProtocol?: string | null;
  bpeCreatedAt?: string | null;
  accessCode?: string | null;
  number?: string | null;
  serie?: string | null;
  paidValue?: string | null;
  issueDateTime?: number | null;
  ticketValue?: string | null;
  icmsBase?: number | null;
  icmsValue?: number | null;
  issuerDocument?: string | null;
  issuerTradingName?: string | null;
  stateCode?: string | null;
  object?: string | null;
  modality?: string | null;
  forma?: string | null;
  cityOrigin?: string | null;
  cityDestiny?: string | null;
  onboardDateTime?: number | null;
  presenceType?: string | null;
  protocol?: string | null;
  route?: string | null;
  tripType?: string | null;
  serviceType?: string | null;
  tripDateTime?: number | null;
}
export interface InterfaceGratuitiesReportList {
  NomeUsuario: string | null;
  DataViagem: string | null;
  InicioProgramado: string | null;
  Linha: string | null;
  Origem: string | null;
  Destino: string | null;
  Assento: string | null;
  Beneficio: string | null;
  Documento: string | null;
  DocumentoAdicional: string | null;
  ValorTotalPassagem: string | null;
  LatitudeSaida: string | null;
  LongitudeSaida: string | null;
}

export interface TimedOutEntriesInterface {
  id: string;
  usedAt: Date;
  usedDate: Date;
  latitude: number;
  longitude: number;
  value: number;
  isVt: number;
  paymentType: number;
  timeout: boolean;
  number: string;
  integrationGroupId: null;
  firstAndSecond: boolean | null;
  createdAt: Date;
  updatedAt: Date;
  dbdId: string;
  lineStopId: string;
  lineSectionId: string;
  tripId: string;
  entryTripId: null | string;
  transportOperatorId: string;
  lineMatrixIntegrationId: null;
  benefitId: null;
  fareBonusId: null;
  fareTaxId: null;
  userId: null | string;
  User?: any;
}

export interface SelectedCompaniesInterface extends SelectedProfilesInterface {}

/*
 * State type
 */
export interface ReportsState {
  readonly chartReportList: ChartReportInterface[];
  readonly kmByDayReportList: KmPerDayReportInterface[];
  readonly passengersAndVehiclesReportList: PassengersAndVehiclesReportInterface | null;
  readonly passengersAndVehiclesByTripReportList: PassengersAndVehiclesByTripReportInterface | null;
  readonly timedOutEntriesList: TimedOutEntriesInterface[];
  readonly pedestriansEntryByTerminalList: PedestriansEntryByTerminalInterface[];
  readonly transportedPassengersList: TransportedPassengersInterface[];
  readonly transportedPassengersByTimeFrameList: TransportedPassengersByTimeFrame[];
  readonly transportedPassengersByTimeFrameByProfileList: TransportedPassengersByTimeFrameByProfile[];
  readonly kmDrivedList: TransportedPassengersInterface[];
  readonly gateEntryReportList: any;
  readonly invoicesList: InvoiceInterface[];
  readonly invoicesListFull: InvoiceInterface[];
  readonly passengersByOriginReportList: PassengersByOrigin[];
  readonly lineDemandReportList: LineDemandReportInterface;
  readonly lineQuantityReportList: LineDemandReportInterface;
  readonly superiorAccessReportList: SuperiorAccessReportInterface;
  readonly dailyDemandReportList: DailyDemandReportInterface;
  readonly dailyQuantityReportList: DailyDemandReportInterface;
  readonly dailyQuantitySeccionedReportList: DailyDemandReportInterface;
  readonly selectedSeccionedLine: number | null;
  readonly chartEntryReportList: ChartEntryReportInterface;
  readonly chartEntryReportSimplifiedList: EntrySimplifiedInterface[];
  readonly entryReportListGrouped: EntryGroupedInterface[];
  readonly chipsListEntry: ChipsInterface[];
  readonly chipsListValue: ChipsInterface[];
  readonly chipsListLine: ChipsInterface[];
  readonly chipsHeatmap: ChipsInterface[];
  readonly chipsFleet: ChipsInterface[];
  readonly chipsTravel: ChipsInterface[];
  readonly chipsPaymentReport: ChipsInterface[];
  readonly heatmapList: HeatmapInterface[];
  readonly paymentList: PaymentInterface[];
  readonly emtuReportList: EmtuReportInterface;
  readonly generalReportList: GeneralReportInterface[];
  readonly travelByLineReportList: TravelByLineInterface[];
  readonly selectedCarsId: string[];
  readonly selectedInvoiceStatus: number | null;
  readonly selectedCars: SelectedCarInterface[];
  readonly selectedTerminals: SelectedTerminalInterface[];
  readonly selectedStartDate: Date;
  readonly selectedEndDate: Date;
  readonly startedAt: Date;
  readonly selectedProfileExpiration: Date;
  readonly numberOfDays: number;
  readonly dateType: string;
  readonly lineType: string;
  readonly statusDeviceRelease: number | null;
  readonly selectedProfiles: SelectedProfilesInterface[];
  readonly selectedPayments: SelectedPaymentsInterface[];
  readonly selectedPaymentStatus: SelectedPaymentStatusInterface[];
  readonly selectedOperationType: SelectedOperationTypeInterface[];
  readonly selectedQRCodes: SelectedQRcodesInterface[];
  readonly selectedLines: SelectedLinesInterface[];
  readonly selectedBenefits: SelectedLinesInterface[];
  readonly selectedSchools: any;
  readonly selectedSectionLines: { start: SectionData[]; end: SectionData[] };
  readonly filenameSelected: string;
  readonly selectedEmployees: SelectedEmployeesInterface[];
  readonly selectedDriverRegistry: SelectedDriverRegistryInterface[];
  readonly selectedReceivePayments: SelectedReceivePaymentsInterface[];
  readonly selectedTripStatus: SelectedQRcodesInterface[];
  readonly selectedTripOrTicket: string;
  readonly selectedSupervisors: SelectedSupervisorInterface[];
  readonly selectedSellingPoint: Array<any>;
  readonly selectedSellingTerminal: Array<any>;
  readonly selectedDbds: SelectedDbdInterface[];
  readonly selectedTokenStatus: SelectedTokenStatus | null;
  readonly selectedCreditType: Array<SelectedCreditType>;
  readonly selectedName: string;
  readonly selectedBpeCode: string;
  readonly selectedBpeNumber: string;
  readonly selectedIncludeBpe: string;
  readonly selectedOrigin: string;
  readonly selectedDestiny: string;
  readonly selectedLineSectionName: string;
  readonly selectedLicense: string;
  readonly selectedPrefix: string;
  readonly selectedQuantity: number | null;
  readonly filterItems: Array<FilterItems>;
  readonly csvFullIsChecked: boolean;
  readonly selectedDocument: string;
  readonly selectedProfileStatus: number | null;
  readonly selectedStatus: number | null;
  readonly selectedCarModel: string;
  readonly selectedAge: string;
  readonly selectedEmail: string;
  readonly selectedTransportCard: string;
  readonly selectedDevice: string;
  readonly selectedCreditCard: string;
  readonly selectedCNPJ: string;
  readonly selectedNSU: string;
  readonly selectedPhone: string;
  readonly history: boolean | null;
  readonly scheduleList: ScheduleInterface[];
  readonly secondScheduleList: ScheduleInterface[];
  readonly scheduleData: ScheduleInterface;
  readonly scheduleDelete: scheduleDeleteInterface;
  readonly paymentRequestList: PaymentRequestInterface[];
  readonly selectedSitCapacity: string;
  readonly selectedFootCapacity: string;
  readonly selectedAccessible: number | null;
  readonly selectedAirConditioned: number | null;
  readonly selectedTicketer: number | null;
  readonly selectedRegistry: string;
  readonly selectedLicenseNumber: string;
  readonly selectedNumber: string;
  readonly selectedCardNumber: string;
  readonly selectedLot: string;
  readonly selectedCardType: number | null;
  readonly selectedCardStatus: number | null;
  readonly selectedTitle: string;
  readonly selectedLineModes: number | null;
  readonly selectedLineModel: number | null;
  readonly selectedCovered: number | null;
  readonly selectedBusBay: number | null;
  readonly selectedSpecialBusStop: number | null;
  readonly selectedResponsible: string;
  readonly selectedTerminalName: string;
  readonly selectedBlockName: string;
  readonly selectedTotalLines: number | null;
  readonly selectedTariff: number | null;
  readonly shipmentLineEntries: ShipmentByLineInterface | null;
  readonly incomingByKmValueList: IncomingByKmValueReportInterface[];
  readonly selectedIncomingTypes: SelectedReportTypesInterface[];
  readonly selectedEmvType: SelectedReportTypesInterface[];
  readonly tripeCollectionReportList: TripCollectionReportInterface[];
  readonly emvReportList: emvReportInterface[];
  readonly bpeReportList: InterfaceBpeReportList[];
  readonly bpeTaxVerificationReportList: InterfaceBpeTaxVerificationReportList[];
  readonly emvDeclinedByReasonReportList: EmvDeclinedByReasonInterface[];
  readonly emvApprovedByBrandReportList: EmvApprovedByBrandInterface[];
  readonly emvApprovedByDebtRecoveryReportList: EmvApprovedByDebtRecoveryInterface[];
  readonly emvApprovedByAttemptsReportList: EmvApprovedByAttemptsInterface[];
  readonly emvApprovedByFirstTapByBrandReportList: EmvApprovedByFirstTapByBrandInterface[];
  readonly emvEntryGetList: EmvEntryGetInterface | null;
  readonly emvEntryGetHistoryList: EmvEntryGetHistoryInterface | null;
  readonly ordersBySchoolsList: OrdersBySchoolInterface[];
  readonly studentCardsList: StudentCardListInterface[];
  readonly selectedBrand: SelectedReportTypesInterface[];
  readonly tripControlDetailsResumeReportList: TripControlDetailResume[];
  readonly creditisBySchoolReportList: CreditisBySchoolListInterface[];
  readonly usageStatisticsReportList: UsageStatisticsInterface[];
  readonly profileByAgeGroupList: ProfileByAgeGroupListInterface[];
  readonly selectedEmvStatus: number | string | null;
  readonly selectedSchoolCode: string | null;
  readonly selectedSchoolType: SelectedTokenStatus[];
  readonly carList: CarList;
  readonly externalReports: ExternalReportsInterface[];
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
  readonly isSearchActive: boolean;
  readonly selectedCompanies: SelectedCompaniesInterface[];
  readonly gratuitiesReportList: InterfaceGratuitiesReportList[];
  readonly employeeTripSapResumeReport: string;
  readonly selectedPaymentDay: Date | null;
  readonly dateTypeBPe: string;
}
